module.exports = __webpack_public_path__ + "img/71.79838911.jpg";